export default "__VITE_ASSET__BbK2voHD__"